<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <register-title class="form__title">{{
      $t("financing sources info")
    }}</register-title>
    <!------------------------------------  INCOME LIST  ----------------->
    <label class="label">{{ $t("income sources list") }}<br /></label>
    <div class="row">
      <div
        class="col-xs-12"
        v-for="(income, income_index) in income_list"
        :key="`income_${income_index}`"
      >
        <div class="pane">
          <div class="row">
            <div class="col-xs-8">
              <div :class="{ deletable: income.delete }">
                <p class="title">
                  {{ income.description }}
                </p>
              </div>
            </div>
            <div class="col-xs-4">
              <p class="pane-list-del" @click="delOldIncome(income_index)">
                {{ $t("delete") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <register-input
          v-model="income_add_text"
          :inputPlaceholder="$t('your income source')"
          componentID="bank-name"
          class="form__input"
        />
        <span class="pane-list-add" @click="addNewIncome(income_add_text)">
          {{ $t("add") }}
        </span>
      </div>
    </div>
    <hr class="horizontal-line" />
    <!------------------------------------  CONDITIONS LIST  ----------------->
    <label class="label"
      >{{ $t("characteristics of financial condition") }}<br
    /></label>
    <p style="color: white; font-size: 10px;">
      {{ $t("(le real estate, values, capital share)") }}
    </p>
    <div class="row">
      <div
        class="col-xs-12"
        v-for="(condition, condition_index) in condition_list"
        :key="`income_${condition_index}`"
      >
        <div class="pane">
          <div class="row">
            <div class="col-xs-8">
              <div :class="{ deletable: condition.delete }">
                <p class="title">
                  {{ condition.description }}
                </p>
              </div>
            </div>
            <div class="col-xs-4">
              <p
                class="pane-list-del"
                @click="delOldCondition(condition_index)"
              >
                {{ $t("delete") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <register-input
          v-model="condition_add_text"
          :inputPlaceholder="$t('characteristics of financial condition')"
          componentID="bank-name"
          class="form__input"
        />
        <span
          class="pane-list-add"
          @click="addNewCondition(condition_add_text)"
        >
          {{ $t("add") }}
        </span>
      </div>
    </div>
    <hr class="horizontal-line" />
    <!------------------------------------  BANK LIST  ----------------->
    <label class="label">{{ $t("bank account list") }}<br /></label>
    <div class="pane" v-for="(bank, bank_index) in bank_list">
      <div class="row">
        <div class="col-xs-9">
          <div class="row">
            <div class="col-xs-6">
              <b>{{ bank.bank_name }}</b>
            </div>
            <div class="col-xs-6">
              <p>{{ bank.bank_account }}</p>
            </div>
          </div>
        </div>
        <div class="col-xs-3">
          <p class="pane-list-del" @click="delOldBank(bank_index)">
            {{ $t("delete") }}
          </p>
        </div>
      </div>
    </div>
    <br />
    <div class="row middle-xs">
      <div class="col-xs-12 col-sm-6">
        <label class="label">{{ $t("choose bank") }}</label>
        <exp-select
          :options="bank_all_list"
          v-model="bank_all_list_selected"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <div class="col-xs-12 col-sm-6">
        <label class="label">{{ $t("other") }}<br /></label>
        <register-input
          v-model="bank_form.bank_name"
          :inputLabel="$t('other')"
          :disabled="bank_all_list_selected != 0"
          :inputPlaceholder="$t('bank name')"
          componentID="bank-name"
          class="form__input"
        />
      </div>
      <div class="col-xs-12 col-sm-6">
        <register-input
          v-model="bank_form.bank_account"
          inputType="text"
          :inputPlaceholder="$t('account number')"
          componentID="bank-name"
          class="form__input"
        />
      </div>
      <div class="col-xs-12 col-sm-6">
        <span class="pane-list-add" @click="addNewBank()">
          {{ $t("add") }}
        </span>
      </div>
    </div>
    <hr class="horizontal-line" />
    <!------------------------------------  SELECTORS (annual income, spends, ) ----------------->
    <div v-if="!isUserLegal">
      <div class="row">
        <div class="col-xs-12">
          <label class="label">{{ $t("total annual income") }}</label>
          <exp-select
            :options="annualIncomeOptions"
            v-model="form.annual_income"
            :title="$t('choose country')"
          ></exp-select>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <label class="label">{{
            $t("financial condition total cost")
          }}</label>
          <exp-select
            :options="finConditionOptions"
            v-model="form.financial_value"
            :title="$t('choose country')"
          ></exp-select>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <label class="label"> {{ $t("liabilities total value") }} </label
          ><br />
          <exp-select
            :options="finLiabilityOptions"
            v-model="form.liabilities_value"
            :title="$t('choose country')"
          ></exp-select>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="select-container">
        <label class="label"
          >{{ $t("countries main operating assets") }}
        </label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.main_operating_assets_country"
          :title="$t('choose country')"
        ></exp-select>
        <br />
        <file-input
          :mini="true"
          :is_uploaded="form_files.legal_financial_statement"
          v-model="form_files.legal_financial_statement"
          @attached="
            saveFile(
              form_files.legal_financial_statement,
              'legal_financial_statement'
            )
          "
          class="form__input-container"
          componentID="doc_3"
        >
          {{ $t("consolidated financial statements") }}
        </file-input>
        <file-input
          :mini="true"
          :is_uploaded="form_files['user-fatca']"
          v-model="form_files['user-fatca']"
          @attached="saveFile(form_files['user-fatca'], 'user-fatca')"
          class="form__input-container"
          componentID="doc_4"
        >
          {{ $t("FATCA tax form (original)") }}
        </file-input>
      </div>
    </div>
    <button type="submit" class="button filled form__button">
      {{ $t("confirm") }}
    </button>
  </form>
</template>

<script>
import RegFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["user_profile"],
  data() {
    return {
      income_add_text: "",
      income_list: [],
      // --------------------------------
      bank_form: {
        bank_account: "",
        bank_name: ""
      },
      bank_list: [],
      bank_all_list: [],
      bank_all_list_selected: "0",
      // --------------------------------
      condition_add_text: "",
      condition_list: [],
      // --------------------------------
      annualIncomeOptions: [],
      finConditionOptions: [],
      finLiabilityOptions: [],
      old_form: null,
      form: {
        annual_income: null,
        financial_value: null,
        liabilities_value: null,
        main_operating_assets_country: null
      },
      form_files: {
        legal_financial_statement: null,
        "user-fatca": null
      }
    };
  },
  mixins: [RegFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    nextStep() {
      this.$router.push({ name: "commercial-conditions" });
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    handleFormSubmit() {
      if (this.isUserLegal) {
        if (
          this.form_files.legal_financial_statement &&
          this.form_files["user-fatca"]
        ) {
          this.saveData();
        } else {
          this.$toasted.clear();
          this.$toasted.show(this.$t("attach files"));
        }
      } else {
        this.saveData();
      }
    },
    fetchForm() {
      try {
        this.income_list = this.user_profile.userIncomeSources;
        this.bank_list = this.user_profile.userBankAccounts;
        this.condition_list = this.user_profile.userFinancialConditions;
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        Object.entries(this.form_files).map(obj => {
          let find_file = this.user_profile.userUploadedDocuments.find(
            file => file.type === obj[0]
          );
          this.form_files[obj[0]] = (find_file ? true : null) || null;
        });
        this.old_form = JSON.parse(JSON.stringify(this.form));
        this.loadSelectableLists();
      } catch (e) {
        console.log(e);
        // ERROR HANDLER
      }
    },
    // ---------------------------------- Load Selectable lists
    loadSelectableLists() {
      const lists = [
        {
          url: "utilities/get-income-info-list",
          variable: "annualIncomeOptions",
          key: "annual_income"
        },
        {
          url: "utilities/get-fin-conditions-list",
          variable: "finConditionOptions",
          key: "financial_value"
        },
        {
          url: "utilities/get-fin-liability-list",
          variable: "finLiabilityOptions",
          key: "liabilities_value"
        }
      ];
      lists.forEach(list => {
        this.loadList(list);
      });
    },
    loadList(config) {
      let url = config.url;
      FhsAxios.get(url, {
        data: {}
      }).then(res => {
        if (res.data.status) {
          this[config.variable] = res.data.result.map(item => {
            item.id = parseInt(item.id);
            item.selected = item.id === this.form[config.key];
            return {
              text: item.name,
              value: item.id
            };
          });
          return;
        }
        this.$toasted.error(this.$t("error"));
      });
    },
    saveData() {
      FhsAxios.post(`user/profile`, this.form).then(res => {
        if (res.data.status) {
          this.$toasted.info(this.$t("changes saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
      });
    },
    // ---------------------------------- INCOME MANAGEMENT
    addNewIncome(text) {
      if (text.length > 0) {
        this.income_list.push({
          description: text
        });
        this.income_add_text = "";
        this.saveIncomeList();
      } else {
        this.$toasted.show(this.$t("empty field"));
      }
    },
    delOldIncome(index) {
      try {
        this.income_list.splice(index, 1);
        this.saveIncomeList();
      } catch (e) {
        this.$toasted.error(this.$t("error"));
      }
    },
    saveIncomeList() {
      this.$toasted.show(this.$t("adding") + "...");
      let url = `user/income-sources`;
      FhsAxios.post(url, this.income_list).then(res => {
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.info(this.$t("changes saved"));
          return;
        }
        this.$toasted.error(this.$t("error"));
      });
    },
    // ---------------------------------- BANK MANAGEMENT
    addNewBank() {
      // console.log(this.bank_all_list_selected);
      if (
        (this.bank_form.bank_name.length > 0 ||
          this.bank_all_list_selected != "0") &&
        this.bank_form.bank_account.length > 0
      ) {
        let data = {
          bank_account: this.bank_form.bank_account,
          bank_name: this.bank_form.bank_name
        };
        if (this.bank_all_list_selected != "0") {
          let selected_bank = this.bank_all_list.find(
            bank => bank.value == this.bank_all_list_selected
          );
          if (selected_bank.value) {
            data = {
              bank_account: this.bank_form.bank_account,
              bank_name: selected_bank.text,
              bank_id: selected_bank.value,
              bic: selected_bank.code
            };
          }
        }
        this.bank_list.push(data);
        this.saveBankList();
        this.bank_all_list_selected = null;
        this.bank_form.bank_name = "";
        this.bank_form.bank_account = "";
      } else {
        this.$toasted.show(this.$t("fill fields"));
      }
    },
    delOldBank(index) {
      try {
        this.bank_list.splice(index, 1);
        this.saveBankList();
      } catch (e) {
        this.$toasted.error(this.$t("error"));
      }
    },
    saveBankList() {
      this.$toasted.show(this.$t("adding") + "...");
      let url = `user/bank-accounts`;
      FhsAxios.post(url, this.bank_list).then(res => {
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.info(this.$t("changes saved"));
          return;
        }
        this.$toasted.error(this.$t("error"));
      });
    },
    // ---------------------------------- INCOME MANAGEMENT
    addNewCondition(text) {
      if (text.length > 0) {
        this.condition_list.push({
          description: text
        });
        this.condition_add_text = "";
        this.saveConditionList();
      } else {
        this.$toasted.show(this.$t("empty field"));
      }
    },
    delOldCondition(index) {
      try {
        this.condition_list.splice(index, 1);
        this.saveConditionList();
      } catch (e) {
        this.$toasted.error(this.$t("error"));
      }
    },
    saveConditionList() {
      this.$toasted.show(this.$t("adding") + "...");
      let url = `user/financial-conditions`;
      FhsAxios.post(url, this.condition_list).then(res => {
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.info(this.$t("changes saved"));
          return;
        }
        this.$toasted.error(this.$t("error"));
      });
    },
    // ----------------------------------------------------------------
    getBankList() {
      FhsAxios.get("bank/list").then(res => {
        let list = res.data.result.banks.map(bank => {
          return {
            value: bank.id,
            text: bank.name,
            code: bank.bic
          };
        });
        this.bank_all_list = [
          { value: 0, text: this.$t("not chosen"), code: null },
          ...list
        ];
      });
    }
  },
  beforeMount() {
    this.fetchForm();
    this.getBankList();
  }
};
</script>

<style scoped></style>
